module.exports = __webpack_public_path__ + "static/logo.d8a9cea6b5c1ff0fdea0a8f088b1b8a8.svg";